module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"creator":"Tender Creator","isLimitedTender":"Is Limited Tender?"},"al":{"creator":"Krijuesi i Tenderit","isLimitedTender":"A është Tender i Kufizuar?"}}')
  delete Component.options._Ctor
}
